import api from "../api";
import {createNamespacedHelpers} from "vuex";

const {mapState} = createNamespacedHelpers('journeyBuilder/composer');

//For some reason inject seems to refuse using Symbols as keys, use a plain string for our provided value
const READONLY_MARKER = Symbol('READONLY_MARKER');
const PROVIDED_READONLY_MARKER = '$_PROVIDED_READONLY_MARKER_$';

let _isLocked;

/**
 * Mixin enabling the option to mark self and all children as readonly
 */
const readonlyMarkableComponentTreeMixin = {
    provide() {
        const vm = this;
        
        return {
            //Ensure reactivity via getter
            [PROVIDED_READONLY_MARKER]: {
                get value() {
                    return vm[READONLY_MARKER];
                }
            }    
        }
    },
    
    data() {
        return {
            [READONLY_MARKER]: false
        }
    },
    
    methods: {
        /**
         * Mark self and all children as readonly
         */
        markComponentTreeReadonly() {
            this[READONLY_MARKER] = true;
        }   
    }
}

export {
    readonlyMarkableComponentTreeMixin
}

export default {
    inject: {
        [PROVIDED_READONLY_MARKER]: { default: undefined }
    },
    
    computed: {
        ...mapState(['hasWritePermission']),
        hasSpecialWritePermission(){
            //Treat both the same for the time being
            return this.hasWritePermission;
        },
        canWrite(){
            //An explicit readonly mode overwrites the more general write permission
            //Readonly mode is active when:
            // * Self is marked as readonly
            // * A component in our parent tree is marked as readonly
            if(
              this[READONLY_MARKER] ||
              (this[PROVIDED_READONLY_MARKER] && this[PROVIDED_READONLY_MARKER].value)
            ) {
                return false;
            }
            
            //Special write permission is always allowed to write, lock, and unlock
            return this.hasSpecialWritePermission || (!_isLocked && this.hasWritePermission);
        },
        isLocked: {
            get() {
                return _isLocked;
            }
        }
    },
    
    data: function(){
        return {
            //Our privates should NOT be prefixed with $_; this seems to tell Vue to make them not reactive(?)
            
            //Initialise values with NULL to ensure our watch functions get triggered
            //when the actual value is set
            hasActivationPermission: null,
            hasDeletePermission: null
        };
    },

    async created(){
        const vm = this;

        await this.$store.dispatch('journeyBuilder/composer/loadPermissions');

        api.validateDeletePermission()
          .then(
            () => vm.hasDeletePermission = true,
            () => vm.hasDeletePermission = false
          );

        api.validateActivationPermission()
          .then(
            () => vm.hasActivationPermission = true,
            () => vm.hasActivationPermission = false
          );
    },

    methods: {
        $_setLockedState(isLocked){
            _isLocked = isLocked;

            //_isLocked is 'global' and thus not reactive
            this.$forceUpdate();
        }
    },
};